import { create } from "zustand";

export enum WsState {
  Connecting = "connecting",
  Connected = "connected",
  Disconnected = "disconnected",
}

interface WsStatusState {
  state: WsState;
  setState: (state: WsState) => void;
}

export const useWsStatus = create<WsStatusState>()((set) => ({
  state: WsState.Connecting,
  setState: (state) => set({ state }),
}));
